import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { HStack } from 'design-system/components/Stack';

const PanelContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ScrollContainer = styled.div`
  overflow: auto;
  flex: 1 0 0;
  min-height: 0;
  z-index: 0;
`;

const PanelFooterContainer = styled.div`
  flex: 0 1 0;
  display: flex;
  padding: ${Spacing[4]} ${Spacing[5]};
  border-top: 1px solid ${({ theme }) => theme.color.border.secondary};
  background-color: ${({ theme }) => theme.color.background.primary};
  z-index: 1;
`;

interface ScrollablePanelWithFooterProps {
  footerContent?: React.ReactNode;
  children: React.ReactNode;
}

const ScrollablePanelWithFooter = ({ children, footerContent }: ScrollablePanelWithFooterProps) => {
  return (
    <PanelContentContainer>
      <ScrollContainer>{children}</ScrollContainer>
      {footerContent && (
        <PanelFooterContainer>
          <HStack>{footerContent}</HStack>
        </PanelFooterContainer>
      )}
    </PanelContentContainer>
  );
};

export default ScrollablePanelWithFooter;
